import { createFileRoute } from '@tanstack/react-router'
import { OrganizationsTable } from './-components/organizations-table'

export const Route = createFileRoute('/_authed/admin/')({
  component: AdminOrganizationsPage,
  beforeLoad: () => ({
    getTitle: () => 'Organizations',
  }),
})

function AdminOrganizationsPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Organizations</h1>
        <p className="text-muted-foreground">Manage organizations and users</p>
      </div>
      <OrganizationsTable />
    </div>
  )
}
